import React from 'react'
import Link from 'gatsby-link'
import './style.scss'

class SiteNavi extends React.Component {
  render() {
    const { location, title } = this.props
    return (
      <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
        <div className="container">
          <Link className="text-center" to="/">
            <h1 className="navbar-brand mb-0 headerTitle">{title}</h1>
          </Link>
          <div className="navbar-nav-scroll">
            <ul className="navbar-nav bd-navbar-nav flex-row">
              <li
                className={
                  (location.pathname === '/predlozhit-stih/'
                    ? 'nav-item active'
                    : 'nav-item',
                  'mr-2 mr-lg-0')
                }
              >
                <Link to={'/predlozhit-stih'} className="nav-link">
                  Предложить стих
                </Link>
              </li>
              <li
                className={
                  location.pathname === '/predlozhit-stih/'
                    ? 'nav-item active'
                    : 'nav-item'
                }
              >
                <a
                  href="https://vk.com/vremyaono"
                  target="_blank"
                  className="nav-link"
                >
                  Сад Духовный
                </a>
              </li>
            </ul>
          </div>
          {/* <div className="navbar-nav flex-row ml-md-auto d-none d-md-flex" /> */}
        </div>
      </nav>
    )
  }
}

export default SiteNavi



// WEBPACK FOOTER //
// ./src/components/SiteNavi/index.jsx